import React from 'react';
import PropTypes from 'prop-types';
import {Alert} from 'react-bootstrap';


class ErrorComponent extends React.Component {


  componentWillUpdate(nextProps, nextState) {
    // TODO: log errors
  }


  render() {
    if (!this.props.error || this.props.error.length === 0) {
      return null;
    } else {
      return (
        <Alert data-cy='error-component' className="mt1" bsStyle="danger">
          { this.props.error.length === 1 ? (this.props.error[0].msg) :
            <ul>
              {
                this.props.error.map((err, i) => {
                  return <li key={i}>{ err.msg }</li>;
                })
              }
            </ul>
          }
        </Alert>
      );
    }
  }
}

ErrorComponent.propTypes = {
  error: PropTypes.array
};

export default ErrorComponent;


// WEBPACK FOOTER //
// ./src/components/ErrorComponent.js